export interface TagDto {
  id: string;
  name: string;
  displayName: string;
  category: number;
  status: number;
  usageCount: number;
  isSystemTag: boolean;
}

export const TagCategory = {
  Platform: 0,
  Caliber: 1,
  PartCategory: 2,
  ReviewSentiment: 3,
  ContentTopic: 4,
  Internal: 5
} as const

export const TagStatus = {
  Pending: 0,
  Active: 1,
  Rejected: 2
} as const

export const TagTargetType = {
  Post: 0,
  Part: 1,
  FirearmModel: 2,
  Build: 3
} as const
